function initializeSASProductDetails() {
  class SASProductDetails {
    constructor() {
      this.container = document.querySelector('.product-details');
      this.data = null;
      this.currentVariant = null;
      this.settings = {};
      
      this.init();
    }

    init() {
      this.loadData();
      this.setupEventListeners();
      this.loadSpecifications();
    }

    loadData() {
      const dataScript = document.getElementById('sas-variant-metafields-data');      
      if (dataScript) {
        this.data = JSON.parse(dataScript.textContent);
        this.currentVariant = this.data.currentVariant;
        this.settings = this.data.settings;
      }
    }

    setupEventListeners() {
    //   Fallback: Listen for the custom variant:changed event
      document.addEventListener('variant:changed', (event) => {
        if (event.detail && event.detail.variant) {
          this.currentVariant = event.detail.variant;
          this.loadSpecifications();
        }
      });
    }

    loadSpecifications() {
        const list = this.container.querySelector('.product-single__metafields ul');
        if (!list) return;
  
        list.innerHTML = '';
  
        const metafields = this.getCurrentVariantMetafields();
        
        if (!metafields || Object.keys(metafields).length === 0) {
          this.container.querySelector('.product-metafields').style.display = 'none';
          return;
        }
  
        const orderSpecs = this.settings.orderSpecifications || '';
        const orderArray = orderSpecs.split(/[\s,]+/).filter(item => item !== '');
        const sortedMetafields = this.sortObjectByCustomOrder(metafields, orderArray);
  
        let hasValidMetafields = false;
  
        for (const [key, value] of Object.entries(sortedMetafields)) {
          if (this.shouldExcludeField(key)) {
            continue;
          }
  
          const displayValue = this.formatDisplayValue(key, value);
          
          if (displayValue === null || displayValue === undefined || displayValue === '') {
            continue;
          }
  
          hasValidMetafields = true;
  
          const listItem = document.createElement('li');
          listItem.innerHTML = `
            <strong>${key.replace(/_/g, ' ')}:</strong>
            <p>${displayValue}</p>
          `;
          list.appendChild(listItem);
        }

        const showSku = this.settings.showSku;
        const sku = this.currentVariant?.sku;

        if(showSku && sku){
          const skuItem = document.createElement('li');
          skuItem.innerHTML = `
          <strong>SKU:</strong>
          <p>${ sku }</p>
          `
          list.appendChild(skuItem)
        }
  
        // Show/hide the entire section based on whether we have metafields 
        const productMetafields = this.container.querySelector('.product-metafields');
        if (productMetafields) {
          productMetafields.style.display = hasValidMetafields ? 'block' : 'none';
        }
    }

    getCurrentVariantMetafields() {
        if (!this.currentVariant) return {};
        
        if (this.currentVariant.metafields) {
          return this.currentVariant.metafields;
        }
  
        // Fallback: find variant in our data
        const variantData = this.getVariantById(this.currentVariant.id);
        return variantData ? variantData.metafields : {};
    }

    getVariantById(variantId) {
      if (!this.data || !this.data.variants) return null;
      return this.data.variants.find(variant => variant.id === variantId);
    }

    sortObjectByCustomOrder(obj, customOrder) {
      const sortedObj = {};

      if (customOrder && customOrder.length > 0) {
        customOrder.forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            sortedObj[key] = obj[key];
          }
        });
      }

      Object.keys(obj).forEach((key) => {
        if (!sortedObj.hasOwnProperty(key)) {
          sortedObj[key] = obj[key];
        }
      });

      return sortedObj;
    }

   formatDisplayValue(key, value) {
      if (key === 'price' && typeof value === 'object' && value.amount && value.currency_code) {
        return this.formatPrice(key, value);
      }

      if (Array.isArray(value)) {
        if (typeof value[0] === 'object') {
          return value.map((v) => v.label || v.value || JSON.stringify(v)).join(', ');
        }
        return value.join(', ');
      }

      if (typeof value === 'object' && value !== null) {
        if (value.label || value.value) {
          return value.label || value.value;
        }
        return JSON.stringify(value);
      }
      return value;
    }

    formatPrice(key, value) {
        if (typeof value === 'object' && value.amount && value.currency_code) {
          const amount = parseFloat(value.amount);
          return new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: value.currency_code 
          }).format(amount);
        }
        return value;
    }

    shouldExcludeField(key) {
      const excludeSpecs = this.settings.excludeSpecifications || '';
      const excludeArray = excludeSpecs
        .split(/[\s,]+/)
        .map((item) => item.trim().toLowerCase().replace(/\s+/g, '_'))
        .filter((item) => item !== '');

      const formattedKey = key.toLowerCase();
      return excludeArray.includes(formattedKey);
    }
  }

  window.sasProductDetails = new SASProductDetails();
}

function checkjQueryAndInit() {
  if (typeof jQuery !== 'undefined') {
    initializeSASProductDetails();
  } else {
    setTimeout(checkjQueryAndInit, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkjQueryAndInit);
} else {
  checkjQueryAndInit();
}